<div
  class="text-white band h-full flex flex-col"
  [class.collapsed]="this.isCollapsed()"
  [ngClass]="{'shown': this.isInformationsBandShown}"
>
  <div class="w-full flex items-center pt-4 pl-4">
    <img
      src="/assets/images/logo/MealCheckWhite.webp"
      alt="Logo DataMeal"
      class="logo"
      [class.w-[10rem]]="!this.isCollapsed()"
      [class.w-[3rem]]="this.isCollapsed()"
    />
    <div class="w-full h-[2px] bg-noir-2-contour mt-auto mb-3 ml-2"></div>
  </div>

  <div
    class="mt-4"
    [class.pr-6]="!isCollapsed()"
    [class.px-2]="isCollapsed()"
    [class.pl-4]="!isCollapsed()"
  >
    <app-profile-card
      class="w-full block h-[38px]"
      (onPreferencesOpenRequest)="this.onPreferencesOpenRequest.emit()"
      [showName]="!this.isCollapsed()"
    />
  </div>

  <div
    [class.px-4]="!this.isCollapsed()"
    [class.px-2]="this.isCollapsed()"
    [class.px-1]="!this.isCollapsed()"
    class="mt-4 space-y-1 overflow-y-auto w-full max-h-[30rem] grid-cols-1"
  >
    <app-navbar-button
      [label]="'navbar.dashboard'"
      svgName="dashboard"
      class="w-full block"
      [url]="'/dashboard'"
      [isCollapsed]="isCollapsed()"
      (click)="handleMobileNavigation()"
    />
    <app-navbar-button
      [label]="'navbar.foyers'"
      svgName="foyers"
      class="w-full block"
      [url]="'/foyers'"
      [isCollapsed]="isCollapsed()"
      (click)="handleMobileNavigation()"
    />
    <app-navbar-button
      [label]="'navbar.tournees'"
      svgName="truck"
      class="w-full block"
      [url]="'/tournees'"
      [isCollapsed]="isCollapsed()"
      (click)="handleMobileNavigation()"
    />
    <app-navbar-button
      [label]="'navbar.order-scans'"
      svgName="scan"
      class="w-full block"
      [url]="'/import-scans'"
      [isCollapsed]="isCollapsed()"
      (click)="handleMobileNavigation()"
    />
  </div>

  @if (!isCollapsed()) {
  <div
    class="w-full border-b border-noir-2-contour mt-2 border-noir-2-contour border-t"
  >
    <p class="pl-4 pt-4 pb-2 font-semibold">
      {{ 'navbar.stats.total-effectives' | translate }}
    </p>
    <div class="grid grid-cols-2 gap-2 px-4 pb-4 mb-2">
      <div class="rounded border border-noir-2-contour p-2 flex items-center">
        <div class="w-8 aspect-square overflow-hidden rounded bg-white">
          <img
            src="/assets/images/representations/communes.png"
            alt=""
            class="w-full h-full object-cover"
          />
        </div>

        <div class="flex flex-col justify-center">
          <p class="ml-2 mb-0 text-sm leading-none translate-y-1">
            {{ 'navbar.stats.commune' | translate }}
          </p>
          <p class="ml-2 text-xl font-bold tabular-nums">{{ communesCount() }}</p>
        </div>
      </div>

      <div class="rounded border border-noir-2-contour p-2 flex items-center">
        <div class="w-8 aspect-square overflow-hidden rounded bg-white">
          <img
            src="/assets/images/representations/old_lady.png"
            alt=""
            class="w-full h-full object-cover"
          />
        </div>

        <div class="flex flex-col justify-center">
          <p class="ml-2 mb-0 text-sm leading-none translate-y-1">
            {{ 'navbar.stats.particulier' | translate }}
          </p>
          <p class="ml-2 text-xl font-bold tabular-nums">{{ guestsCount() }}</p>
        </div>
      </div>
    </div>
  </div>
  }

  <div
    class="w-full mt-auto pb-4 pt-3 border-t border-noir-2-contour px-4 relative settings-container"
  >
    <app-navbar-button
      label="navbar.collapse"
      [svgName]="isCollapsed() ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left'"
      [svgType]="'material'"
      class="w-full block settings-button mb-2 collapse-btn"
      (onClick)="isCollapsed.set(!isCollapsed())"
      [isCollapsed]="isCollapsed()"
    />
    @if (areSettingsEnabled) {
    <div class="settings-wrapper">
      <!-- Desktop dropdown (horizontal à droite) -->
      <div class="desktop-dropdown hidden md:flex">
        <app-navbar-button
          [label]="'navbar.settings'"
          svgName="settings"
          class="w-full block settings-button"
          [isCollapsed]="isCollapsed()"
        />

        <!-- Safety triangle pour éviter la fermeture du dropdown -->
        <div class="safety-zone"></div>

        <div
          class="dropdown-menu bg-noir-2 p-2 rounded border border-noir-2-contour translate-y-2"
        >
          <app-navbar-button
            [label]="'navbar.setting.users'"
            svgName="group"
            svgType="material"
            class="w-full block dropdown-item"
            [url]="'/settings/users'"
            [isCollapsed]="false"
          />
          <app-navbar-button
            [label]="'navbar.setting.diets'"
            svgName="fork_spoon"
            class="w-full block"
            svgType="material-symbols-outlined"
            [url]="'/settings/diets'"
            [isCollapsed]="false"
          />
          <app-navbar-button
            [label]="'navbar.setting.communes'"
            svgName="apartment"
            svgType="material-symbols-outlined"
            class="w-full block"
            [url]="'/settings/communes'"
            [isCollapsed]="false"
          />
          <app-navbar-button
            [label]="'navbar.setting.week_models'"
            svgName="calendar_month"
            class="w-full block"
            svgType="material-symbols-outlined"
            [url]="'/settings/week-models'"
            [isCollapsed]="false"
          />

          <app-navbar-button
            [label]="'navbar.editions'"
            svgName="scan"
            svgType="svg"
            class="w-full block"
            [url]="'/settings/editions'"
            [isCollapsed]="false"
          />

          <app-navbar-button
            [label]="'navbar.setting.delivery_rounds'"
            svgName="truck"
            svgType="svg"
            class="w-full block"
            [url]="'/settings/delivery-rounds'"
            [isCollapsed]="false"
          />

          <app-navbar-button
            [label]="'navbar.setting.sync'"
            svgName="cloud-sync"
            class="w-full block"
            svgType="svg"
            [isCollapsed]="false"
            (onClick)="syncRequested()"
          />
        </div>
      </div>

      <!-- Mobile dropdown (vertical en dessous) -->
      <div class="mobile-dropdown md:hidden relative w-full max-h-64 overflow-y-auto">
        <app-navbar-button
          [label]="'navbar.settings'"
          svgName="settings"
          class="w-full block"
          [isCollapsed]="isCollapsed()"
          (onClick)="isSettingsDropdownShown = !isSettingsDropdownShown"
        />

        <div
          class="mobile-menu px-2"
          [ngClass]="{'open': isSettingsDropdownShown}"
        >
          <app-navbar-button
            [label]="'navbar.setting.users'"
            svgName="group"
            class="w-full block"
            svgType="material"
            [url]="'/settings/users'"
            [isCollapsed]="isCollapsed()"
            (click)="handleMobileNavigation()"
          />
          <app-navbar-button
            [label]="'navbar.setting.diets'"
            svgName="fork_spoon"
            svgType="material-symbols-outlined"
            class="w-full block"
            [url]="'/settings/diets'"
            [isCollapsed]="isCollapsed()"
            (click)="handleMobileNavigation()"
          />
          <app-navbar-button
            [label]="'navbar.setting.communes'"
            svgName="apartment"
            class="w-full block"
            svgType="material-symbols-outlined"
            [url]="'/settings/communes'"
            [isCollapsed]="isCollapsed()"
            (click)="handleMobileNavigation()"
          />
          <app-navbar-button
            [label]="'navbar.setting.week_models'"
            svgName="calendar_month"
            class="w-full block"
            svgType="material-symbols-outlined"
            [url]="'/settings/week-models'"
            [isCollapsed]="isCollapsed()"
            (click)="handleMobileNavigation()"
          />

          <app-navbar-button
            [label]="'navbar.editions'"
            svgName="scan"
            svgType="svg"
            class="w-full block"
            [url]="'/settings/editions'"
            [isCollapsed]="isCollapsed()"
            (click)="handleMobileNavigation()"
          />

          <app-navbar-button
            [label]="'navbar.setting.delivery_rounds'"
            svgName="truck"
            svgType="svg"
            class="w-full block"
            [url]="'/settings/delivery-rounds'"
            [isCollapsed]="isCollapsed()"
            (click)="handleMobileNavigation()"
          />
          <app-navbar-button
            [label]="'navbar.setting.sync'"
            svgName="cloud-sync"
            class="w-full block"
            svgType="svg"
            (onClick)="syncRequested()"
            [isCollapsed]="false"
          />
        </div>
      </div>
    </div>
    }
  </div>

  <button class="toggle-band" (click)="this.toggleInformationsBand()">
    <span class="material-icons">
      {{ this.isInformationsBandShown ? 'keyboard_arrow_left' :
      'keyboard_arrow_right' }}
    </span>
  </button>
</div>

@if (this.isInformationsBandShown) {
<div class="blur-back" (click)="this.toggleInformationsBand()"></div>
}
